<template>
  <div>
    <b-form-group label="Please select action if duplicated scenarios exist">
      <b-form-radio v-model="selected" name="save-options" value="skip">Skip new</b-form-radio>
      <b-form-radio v-model="selected" name="save-options" value="override">Override existing</b-form-radio>
    </b-form-group>

    <b-row>
      <b-col class="text-right">
        <b-button @click="cancel">Cancel</b-button>
        <b-button
          variant="primary"
          :disabled="!selected"
          @click="save"
        >
          Save
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: ''
    }
  },
  methods: {
    save() {
      this.$emit('save', this.selected);
    },
    cancel() {
      this.$emit('cancel');
    }
  }
}
</script>
